import type React from 'react';
import { HelpCircle } from 'lucide-react';

// The shared Visão Geral card header: a navy icon badge + title + subtitle,
// optionally with a beta chip. Every overview card leads with this so they read
// as one family. `icon` is any lucide-style component (or the TennisBall icon).
interface CardHeadProps {
  icon: React.ElementType;
  title: string;
  subtitle?: React.ReactNode;
  /** Shows the small "beta" chip in the card's top-right corner. The host card
      must be position:relative (e.g. .tips-card) for it to anchor correctly. */
  beta?: boolean;
  /** When set, renders a "?" button on the right that opens a metric-explanation
      sheet (same affordance as the In Depth cards). */
  onInfo?: () => void;
  /** Accessible label for the "?" button (usually the card's metric name). */
  infoLabel?: string;
}

const CardHead: React.FC<CardHeadProps> = ({
  icon: Icon,
  title,
  subtitle,
  beta,
  onInfo,
  infoLabel,
}) => (
  <div className="card-head">
    <span className="card-head-badge">
      <Icon size={17} strokeWidth={2} />
    </span>
    <div className="card-head-text">
      <span className="card-head-title">{title}</span>
      {subtitle ? <span className="card-head-subtitle">{subtitle}</span> : null}
    </div>
    {onInfo ? (
      <button
        type="button"
        className="info-btn"
        onClick={onInfo}
        aria-label={infoLabel}
      >
        <HelpCircle size={15} strokeWidth={2} />
      </button>
    ) : null}
    {beta ? <span className="card-head-beta">beta</span> : null}
  </div>
);

export default CardHead;
